import bootLayout from 'static/script/app/boot/boot-layout';
import SelectPaymentUI from 'static/script/app/ui/checkout/select-payment-ui';
import BinFormUI from 'static/script/app/ui/bin-form-ui';
import PaymentOptionsUI from 'static/script/app/ui/checkout/payment-options-ui';

export default initData => {
    bootLayout(initData);

    if (!initData.pageSpecificData.IsHybridAppContextForAndroid) {
        SelectPaymentUI.attachTo('[data-checkout-select-payment]');
    }
    BinFormUI.attachTo('[data-bin-form]');
    PaymentOptionsUI.attachTo('[data-checkout-payment-options]');
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/pages/checkout-select-payment.js